export const tripTypes = [
  { value: 'conf', tripType: 'Confirmation Number' },
  { value: 'card', tripType: 'Credit/Debit Card Number' },
  { value: 'ticket', tripType: 'Ticket Number' }
];

export const iropMyTripsErrorRedirect = '/my-trips/search?errorCodes=IROPERROR';
